import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";

import Home from "./Pages/Home";
import Services from "./Pages/Services";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Blog from "./Pages/Blog";
import BlogDetail from "./Pages/BlogDetail";
import BlogDetail1 from "./Pages/BlogDetail1";
import BlogDetail2 from "./Pages/BlogDetail2";
import BlogDetail3 from "./Pages/BlogDetail3";

function App() {

  // ✅ ResizeObserver error suppress (Elfsight fix)
  useEffect(() => {
    const originalError = console.error;

    console.error = (...args) => {
      if (
        typeof args[0] === "string" &&
        args[0].includes("ResizeObserver loop")
      ) {
        return;
      }
      originalError(...args);
    };

    return () => {
      console.error = originalError;
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogdetail" element={<BlogDetail />} />
        <Route path="/blogdetail1" element={<BlogDetail1 />} />
        <Route path="/blogdetail2" element={<BlogDetail2 />} />
        <Route path="/blogdetail3" element={<BlogDetail3 />} />
      </Routes>
    </Router>
  );
}

export default App;